// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Segments_actions_LhBva{display:flex;align-items:center;flex-flow:row nowrap;margin-bottom:16px}.Segments_filter_24lwD{margin-right:16px}.Segments_indexRowCell_332ot{display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center}.Segments_indexRowCellIcon_3JuIO{cursor:pointer}.Segments_segment_2IZlC{margin-right:16px;font-size:.9em}.Segments_date-group-holder_3I53E{width:135px;margin-right:16px}.Segments_next-to-last_3BpZ6{flex-grow:1}.Segments_settings_38GE-{position:relative;top:3px}.Segments_button_2CtVn{margin-top:16px;position:absolute}", ""]);
// Exports
exports.locals = {
	"actions": "Segments_actions_LhBva",
	"filter": "Segments_filter_24lwD",
	"indexRowCell": "Segments_indexRowCell_332ot",
	"indexRowCellIcon": "Segments_indexRowCellIcon_3JuIO",
	"segment": "Segments_segment_2IZlC",
	"date-group-holder": "Segments_date-group-holder_3I53E",
	"next-to-last": "Segments_next-to-last_3BpZ6",
	"settings": "Segments_settings_38GE-",
	"button": "Segments_button_2CtVn"
};
module.exports = exports;
